import { useEffect } from "react";
import { SquareLoader } from "screens/Main/components/Loader/SquareLoader";
import { associatedTokensService } from "services/associatedTokensService";
import { useAssociatedTokensStore } from "stores/associatedTokens";

export const AssociatedTokens = () => {
  const {
    tokens,
    total,
    page,
    pageSize,
    isLoading,
    searchQuery,
    isHidden,
    setPage,
    setSearchQuery,
    setIsHidden,
    setPageSize,
  } = useAssociatedTokensStore();

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newSize: number) => {
    setPageSize(newSize);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const handleIsHiddenChange = () => {
    setIsHidden(!isHidden);
    setPage(1);
  };

  const toggleHideStatus = async (tokenId: string, currentStatus: boolean) => {
    await associatedTokensService.toggleHideStatus(tokenId, !currentStatus);
    associatedTokensService.fetchTokens();
  };

  useEffect(() => {
    associatedTokensService.fetchTokens();
  }, [page, pageSize, searchQuery, isHidden]);

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-semibold mb-4">Associated Tokens</h1>

      <div className="mb-4 flex items-center space-x-4">
        <input
          type="text"
          placeholder="Search by name or twitter"
          value={searchQuery}
          onChange={handleSearchChange}
          className="px-4 py-2 border text-black rounded-lg w-1/2 focus:outline-none"
        />

        <div className="flex items-center space-x-2">
          <label className="font-medium">Hidden</label>
          <input
            type="checkbox"
            checked={isHidden}
            onChange={handleIsHiddenChange}
            className="form-checkbox h-5 w-5"
          />
        </div>
      </div>

      {isLoading ? (
        <div className="flex w-full  my-[20px] justify-center  items-center">
          <SquareLoader size={32} />
        </div>
      ) : (
        <table className="min-w-full table-auto">
          <thead>
            <tr className="bg-gray-500">
              <th className="px-4 py-2 text-left">Name</th>
              <th className="px-4 py-2 text-left">Symbol</th>
              <th className="px-4 py-2 text-left">Network</th>
              <th className="px-4 py-2 text-left">Twitter</th>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-4 py-2 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {tokens.map((token) => (
              <tr key={token.address} className="border-b">
                <td className="px-4 py-2">{token.name}</td>
                <td className="px-4 py-2">{token.symbol}</td>
                <td className="px-4 py-2">{token.network}</td>
                <td
                  className="px-4 py-2 cursor-pointer"
                  onClick={() => window.open(token.twitter, "_blank")}
                >
                  {token.twitter}
                </td>
                <td className="px-4 py-2">
                  <span
                    className={`text-sm font-semibold ${
                      token.is_hidden ? "text-red-500" : "text-green-500"
                    }`}
                  >
                    {token.is_hidden ? "Hidden" : "Visible"}
                  </span>
                </td>
                <td className="px-4 py-2">
                  <button
                    onClick={() => toggleHideStatus(token.id, token.is_hidden)}
                    className={`px-4 py-2 rounded-lg text-white ${
                      token.is_hidden ? "bg-green-500" : "bg-red-500"
                    }`}
                  >
                    {token.is_hidden ? "Unhide" : "Hide"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="flex justify-between items-center mt-6">
        <button
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg disabled:bg-gray-300 disabled:text-black"
        >
          Previous
        </button>

        <span className="text-lg">
          Page {page} of {Math.ceil(total / pageSize)}
        </span>

        <button
          onClick={() => handlePageChange(page + 1)}
          disabled={page * pageSize >= total}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg disabled:bg-gray-300  disabled:text-black"
        >
          Next
        </button>
      </div>

      <div className="mt-4 flex justify-end">
        <select
          value={pageSize}
          onChange={(e) => handlePageSizeChange(Number(e.target.value))}
          className="px-4 py-2 border rounded-lg text-white  focus:outline-none"
        >
          <option value={10}>10 per page</option>
          <option value={20}>20 per page</option>
          <option value={50}>50 per page</option>
        </select>
      </div>
    </div>
  );
};
